<template>
  <div id="menu" v-bind:class="{ visible: isOpen }" v-if="metadata">
    <div id="menuOpener" @click="switchVisibility">
      <span id="open"><i class="fa-solid fa-caret-left"></i></span>
      <span id="close"><i class="fa-solid fa-caret-right"></i></span>
    </div>
    <div class="wrap">
      <p class="lead text-center" id="infoHeader">
        {{ wvconfig.config.value.name }}
      </p>
      <p class="text-muted fw-light h6" v-html="infoHTMLMarkdown">
      </p>
      <section>
        <p class="lead"><i class="fas fa-water"></i> Karte</p>
        <table class="map-legend">
          <template v-if="availableLayers.includes(Constants.layer.bauwerke)">
            <tr style="background-color: #f2f2f2;">
              <td width="31px" rowspan="3" class="layer-visibility-toggle" @click="toggleLayerVisibility($event, 'bauwerke')" title="Layersichtbarkeit">
                <i v-if="layerVisibility.bauwerke" class="fa-regular fa-eye"></i>
                <i v-else style="color: #808080" class="fa-regular fa-eye-slash"></i>
              </td>
              <td width="20px" rowspan="3" class="layer-visibility-toggle" @click="toggleLayerVisibility($event, 'bauwerkeLabel')" title="Label">
                <i v-if="layerVisibility.bauwerkeLabel" class="fa-solid fa-note-sticky"></i>
                <i v-else style="color: #808080" class="fa-regular fa-note-sticky"></i>
              </td>
              <td><img style="width:1.5em" :src="'icon/speicher.svg'" /></td>
              <td>Speicher</td>
            </tr>
            <tr style="background-color: #f2f2f2;">
              <td><img :src="'icon/vz.svg'" /></td>
              <td>Abzweig</td>
            </tr>
            <tr style="background-color: #f2f2f2;">
              <td><img :src="'icon/ka.svg'" /></td>
              <td>Kläranlage</td>
            </tr>
            <tr>
              <td class="layer-visibility-toggle" @click="toggleLayerVisibility($event, 'systemPlan')" title="Layersichtbarkeit">
                <i v-if="layerVisibility.systemPlan" class="fa-regular fa-eye"></i>
                <i v-else style="color: #808080" class="fa-regular fa-eye-slash"></i>
              </td>
              <td></td>
              <td><div style="border-bottom: solid; border-width: 2px; color: black;"></div></td>
              <td>Systemplan der Bauwerke</td>
            </tr>
          </template>
          <template v-if="availableLayers.includes(Constants.layer.transportelemente)">
            <tr style="background-color: #f2f2f2;">
              <td class="layer-visibility-toggle" @click="toggleLayerVisibility($event, 'transportelemente')" title="Layersichtbarkeit">
                <i v-if="layerVisibility.transportelemente" class="fa-regular fa-eye"></i>
                <i v-else style="color: #808080" class="fa-regular fa-eye-slash"></i>
              </td>
              <td class="layer-visibility-toggle" @click="toggleLayerVisibility($event, 'transportelementeLabel')" title="Label">
                <i v-if="layerVisibility.transportelementeLabel" class="fa-solid fa-note-sticky"></i>
                <i v-else style="color: #808080" class="fa-regular fa-note-sticky"></i>
              </td>
              <td><div style="border-bottom: solid; border-width: 4px; color: blue;"></div></td>
              <td>Gewässer mit Transportelementen</td>
            </tr>
          </template>
          <template v-if="availableLayers.includes(Constants.layer.gewaesser)">
            <tr>
              <td class="layer-visibility-toggle" @click="toggleLayerVisibility($event, 'gewaesser')" title="Layersichtbarkeit">
                <i v-if="layerVisibility.gewaesser" class="fa-regular fa-eye"></i>
                <i v-else style="color: #808080" class="fa-regular fa-eye-slash"></i>
              </td>
              <td class="layer-visibility-toggle" @click="toggleLayerVisibility($event, 'gewaesserLabel')" title="Label">
                <i v-if="layerVisibility.gewaesserLabel" class="fa-solid fa-note-sticky"></i>
                <i v-else style="color: #808080" class="fa-regular fa-note-sticky"></i>
              </td>
              <td><div style="border-bottom: solid; border-width: 1px; color: blue;"></div></td>
              <td>Gewässer ohne Transportelemente</td>
            </tr>
          </template>
          <template v-if="availableLayers.includes(Constants.layer.teilgebiete)">
            <tr style="background-color: #f2f2f2;">
              <td class="layer-visibility-toggle" @click="toggleLayerVisibility($event, 'teilgebiete')" title="Layersichtbarkeit">
                <i v-if="layerVisibility.teilgebiete" class="fa-regular fa-eye"></i>
                <i v-else style="color: #808080" class="fa-regular fa-eye-slash"></i>
              </td>
              <td class="layer-visibility-toggle" @click="toggleLayerVisibility($event, 'teilgebieteLabel')" title="Label">
                <i v-if="layerVisibility.teilgebieteLabel" class="fa-solid fa-note-sticky"></i>
                <i v-else style="color: #808080" class="fa-regular fa-note-sticky"></i>
              </td>
              <td ><div class="legend-symbol" style="border: solid; border-color: red; height: 100%"></div></td>
              <td>Natürliches Teileinzugsgebiet</td>
            </tr>
          </template>
          <template v-if="availableLayers.includes(Constants.layer.kanalFlaechen)">
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td >Kanalisierte Fläche:</td>
            </tr>
            <tr>
              <td rowspan="3" class="layer-visibility-toggle" @click="toggleLayerVisibility($event, 'kanalFlaechen')" title="Layersichtbarkeit">
                <i v-if="layerVisibility.kanalFlaechen" class="fa-regular fa-eye"></i>
                <i v-else style="color: #808080" class="fa-regular fa-eye-slash"></i>
              </td>
              <td rowspan="3" class="layer-visibility-toggle" @click="toggleLayerVisibility($event, 'kanalFlaechenLabel')" title="Label">
                <i v-if="layerVisibility.kanalFlaechenLabel" class="fa-solid fa-note-sticky"></i>
                <i v-else style="color: #808080" class="fa-regular fa-note-sticky"></i>
              </td>
              <td><div class="legend-symbol" style="background-color: rgba(255, 153, 187, 0.6);"></div></td>
              <td>Mischsystem</td>
            </tr>
            <tr>
              <td><div class="legend-symbol" style="background-color: rgba(128, 212, 255, 0.6);"></div></td>
              <td>Trennsystem</td>
            </tr>
            <tr>
              <td><div class="legend-symbol" style="background-color: rgba(211, 211, 211, 0.6);"></div></td>
              <td>Ungesetzt</td>
            </tr>
          </template>
        </table>
      </section>
      <section v-if="backgroundlayers?.length > 0">
        <p class="lead"><i class="fas fa-layer-group"></i> Layer</p>
        <div v-if="additionalLayers" style="padding: 2px;">
          <div v-for="layer of additionalLayers.filter(l => l.label && l.canToggle)" :key="layer.id">
            <label class="switch">
              <input type="checkbox" v-model="additionalLayerVisibility[layer.id]" @change="toggleAddLayer(layer.id)">
              <span class="slider round"></span>
            </label>
            <span v-text="layer.label" style="padding-left: 2px;"></span>
          </div>
        </div>
        <div class='legend-title'>Hintergrundkarte</div>
        <div class="dropdown layerselect" v-if="wvconfig.initialized">
          <button class="btn btn-secondary dropdown-toggle" id="dropdown-button" type="button" @click="toggleLayerMenu">
            <template v-if="selectedBackgroundLayer == null">
              <i :class="`fas fa-${backgroundlayers[wvconfig.getDefaultBackgroundLayerIndex()].icon}`"></i> <span v-text="backgroundlayers[wvconfig.getDefaultBackgroundLayerIndex()].label"></span>
            </template>
            <template v-else>
              <i :class="`fas fa-${selectedBackgroundLayer.icon}`"></i> <span v-text="selectedBackgroundLayer.label"></span>
            </template>
          </button>
          <div class="dropdown-menu" :class="{show: layerMenuVisibility}" id="dropdown-menu">
            <div v-for="layer of backgroundlayers" :key="layer.id" class="dropdown-item">
              <div @click="selectLayer(layer)">
                <i :class="`fas fa-${layer.icon}`"></i> <span v-text="layer.label"></span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="Hilfe">
        <p class="lead "><i class="fas fa-info-circle"></i> Hilfe</p>
        <p><button class="btn btn-info" style="width: 100%;" @click="playTour">Einführung starten</button></p>
      </section>
      <section>
        <p>
          <a href="https://www.hydrotec.de/unternehmen/kontakt/impressum/" target="_blank" rel="noopener" class="text-muted"> Impressum </a>
        </p>
        <p>
          <a href="https://www.hydrotec.de/unternehmen/kontakt/datenschutz-2/" target="_blank" rel="noopener" class="text-muted"> Datenschutz </a>
        </p>
      </section>
    </div>
    <span class="menu-footer">
      <a target="_blank" rel="noopener" href="https://www.hydrotec.de">
        <img style="max-width: 71px; max-height: 25px;" :src="'icon/Hydrotec.png'" />
      </a>
      <span style="float: right;">
        MapView v. <span v-text="mapviewVersion"></span>
      </span>
    </span>
  </div>
</template>

<script lang="ts">

import { computed, ref, shallowRef, watch } from 'vue';
import apifetch from 'vueforms/src/utils/apifetch';
import type { Ref } from 'vue';
import * as baseConfig  from "../../src/js/baseConfig";
import NasimMapviewtour from "../NasimMapviewtour";
import Constants from "./Constants";
import markdownParser from "vueforms/src/MarkdownParserInstance";
import utils from "../../src/js/utils";

export default {
  props: {
    wvconfig: {
      type: Object,
      required: true
    },
    backgroundlayers: {
      type: Array,
      required: false
    },
    additionalLayers: {
      type: Array,
      required: false
    },
    availableLayers: {
      type: Array,
      required: true
    }
  },
  emits: [
    "layerVisibility",
    "selectedBackgroundLayer",
    "toggleAdditionalLayer"
  ],
  setup(props, {emit}){

    //Bei einem Klick außerhlab das OptionsMenü schließen
    //Bei Klick innerhalb des Menüs das Dropdown-Menü zur Layerauswahl schließen
    window.addEventListener("click", (e) => {
      const button = document.getElementById("dropdown-button");
      if (e.target.id == "dropdown-button" || button?.contains(e.target)) {
        return;
      }
      const menu = document.getElementById("menu");
      if (menu.contains(e.target)) {
        layerMenuVisibility.value = false;
        return;
      }
      isOpen.value = false;
    });

    let metadata = ref();
    let selectedBackgroundLayer = shallowRef(null);
    let layerMenuVisibility = shallowRef(false);
    let additionalLayerVisibility = ref({
      lastChange: null
    });


    function selectLayer(layer) {
      selectedBackgroundLayer.value = layer;
      emit("selectedBackgroundLayer", layer);
      layerMenuVisibility.value = false;
    }

    function toggleLayerMenu() {
      layerMenuVisibility.value = !layerMenuVisibility.value;
      if (layerMenuVisibility.value) {
        document.getElementById("dropdown-menu")?.classList.add("show");
        const menu = document.getElementsByClassName("wrap")[0];
        menu.scrollTo({top: menu.scrollHeight, behavior: 'smooth'});
      } 
    }

    async function getMetaData() { 
      try {
        let respSe = await apifetch(baseConfig.getBaseURL() + "modeldata/Metadata.json").then(r => r.json());
        metadata.value = await respSe;
      }
      catch (error){
        console.error('Error:', error);
        throw error;
      }
    }

    getMetaData();

    let isOpen = ref(true);

    const switchVisibility = () => {
      isOpen.value = !isOpen.value;
    }

    let layerVisibility : Ref<Record<string, boolean | string>> = ref({
      bauwerke: true,
      bauwerkeLabel: false,
      systemPlan: true,
      transportelemente: true,
      transportelementeLabel: false,
      gewaesser: true,
      gewaeesserLabel: false,
      teilgebiete: true,
      teilgebieteLabel: false,
      kanalFlaechen: true,
      kanalFlaechenLabel: false,
      lastChange: ""
    });

    const toggleLayerVisibility = (event, layer: string) => {
      layerVisibility.value[layer] = !layerVisibility.value[layer];
      layerVisibility.value.lastChange = layer;
      emit("layerVisibility", layerVisibility.value);
      layerMenuVisibility.value = false;
      event.stopPropagation();
    }

    const toggleAddLayer = (layerId) => {
      additionalLayerVisibility.value.lastChange = layerId;
      emit("toggleAdditionalLayer", additionalLayerVisibility.value);
    }

    watch(() => props.additionalLayers, (newVal) => { 
      if (!newVal) {
        return;
      }
      for (let layer of newVal) {
        additionalLayerVisibility.value[layer.id] = layer.layer.getVisible();
      }
    }, {deep: true});

    function playTour() {
      NasimMapviewtour.start();
    }

    const infoHTMLMarkdown = computed(() => {
      return markdownParser.render(props.wvconfig.config.value.infoHTML ? props.wvconfig.config.value.infoHTML : "");
    });

    return {
      switchVisibility,
      isOpen,
      metadata,
      layerVisibility,
      toggleLayerVisibility,
      selectedBackgroundLayer,
      selectLayer,
      toggleLayerMenu,
      layerMenuVisibility,
      additionalLayerVisibility,
      toggleAddLayer,
      playTour,
      Constants,
      infoHTMLMarkdown,
      mapviewVersion: utils.getBuildDate()
    }
  }
}
</script>
<style>
</style>